import type React from "react";
import { Navbar, Container } from "reactstrap";
import { useAppSelector } from "../hooks/useStore";
import { Link } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";

const NavBar: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <Navbar
      className="shadow-lg border-0 py-3"
      style={{
        background:
          "linear-gradient(135deg, #03045e 0%, #0077b6 50%, #00b4d8 100%)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Container className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div
            className="d-inline-flex align-items-center justify-content-center me-3"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(202, 240, 248, 0.2)",
              borderRadius: "12px",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(202, 240, 248, 0.3)",
            }}
          >
            <Shield size={24} className="text-white" />
          </div>
          <div>
            <h4 className="mb-0 text-white fw-bold">PIIProtect</h4>
            <small className="text-white opacity-75">
              Protection Management
            </small>
          </div>
        </div>

        {isAuthenticated && (
          <div className="d-flex align-items-center">
            <Link
              to="/signout"
              className="btn border-0 shadow-sm px-4 py-2 fw-semibold text-decoration-none d-inline-flex align-items-center"
              style={{
                background: "rgba(202, 240, 248, 0.2)",
                color: "white",
                borderRadius: "25px",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(202, 240, 248, 0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(202, 240, 248, 0.3)";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(3, 4, 94, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(202, 240, 248, 0.2)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <LogOut size={16} className="me-2" />
              Sign Out
            </Link>
          </div>
        )}
      </Container>
    </Navbar>
  );
};

export default NavBar;
